module.exports = __webpack_public_path__ + "static/media/ODS04.52c5a24d.jpg";